
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/calendar/jst/TimeBlockRow';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  return "class=\"locked\"";
  }

function program3(depth0,data) {
  
  
  return "disabled";
  }

function program5(depth0,data) {
  
  
  return " disabled";
  }

function program7(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <a href=\"#\" class=\"delete-block-link icon-end\">\n        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.time_block_row")
  },data:data},helper ? helper.call(depth0, "calendar.time_block_row.delete_link", "Delete Time Range", options) : helperMissing.call(depth0, "t", "calendar.time_block_row.delete_link", "Delete Time Range", options)))
    + "</span>\n      </a>\n    ";
  return buffer;
  }

  buffer += "<tr ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.locked), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n  <td class=\"date-column\">\n    <input name=\"date\" class=\"date_field\"\n      value=\""
    + escapeExpression((helper = helpers.fcMomentToDateString || (depth0 && depth0.fcMomentToDateString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.date), "default", options) : helperMissing.call(depth0, "fcMomentToDateString", (depth0 && depth0.date), "default", options)))
    + "\"\n      aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.time_block_row")
  },data:data},helper ? helper.call(depth0, "calendar.time_block_row.date_label", "Date", options) : helperMissing.call(depth0, "t", "calendar.time_block_row.date_label", "Date", options)))
    + escapeExpression((helper = helpers.datepickerScreenreaderPrompt || (depth0 && depth0.datepickerScreenreaderPrompt),options={hash:{},data:data},helper ? helper.call(depth0, "date", options) : helperMissing.call(depth0, "datepickerScreenreaderPrompt", "date", options)))
    + "\"\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.locked), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " type=\"text\"\n      data-tooltip title=\""
    + escapeExpression((helper = helpers.accessibleDateFormat || (depth0 && depth0.accessibleDateFormat),options={hash:{},data:data},helper ? helper.call(depth0, "date", options) : helperMissing.call(depth0, "accessibleDateFormat", "date", options)))
    + "\"/>\n    </div>\n  </td>\n  <td colspan=\"2\">\n      <div role=\"radiogroup\" aria-labelledby=\"time-range-column\" style=\"display: flex\">\n        <span class=\"start-time-column\">\n          <input name=\"start_time\" class=\"time_field start_time\" value=\""
    + escapeExpression((helper = helpers.fcMomentToString || (depth0 && depth0.fcMomentToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.start), "tiny", options) : helperMissing.call(depth0, "fcMomentToString", (depth0 && depth0.start), "tiny", options)))
    + "\"\n            aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.time_block_row")
  },data:data},helper ? helper.call(depth0, "calendar.time_block_row.start_time_label", "Start Time", options) : helperMissing.call(depth0, "t", "calendar.time_block_row.start_time_label", "Start Time", options)))
    + escapeExpression((helper = helpers.datepickerScreenreaderPrompt || (depth0 && depth0.datepickerScreenreaderPrompt),options={hash:{},data:data},helper ? helper.call(depth0, "time", options) : helperMissing.call(depth0, "datepickerScreenreaderPrompt", "time", options)))
    + "\"\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.locked), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " type=\"text\"\n            data-tooltip title=\""
    + escapeExpression((helper = helpers.accessibleDateFormat || (depth0 && depth0.accessibleDateFormat),options={hash:{},data:data},helper ? helper.call(depth0, "time", options) : helperMissing.call(depth0, "accessibleDateFormat", "time", options)))
    + "\"/>\n        </span>\n        <span class=\"separator-column\">-</span>\n        <span class=\"end-time-column\">\n          <input name=\"end_time\" class=\"time_field end_time\" value=\""
    + escapeExpression((helper = helpers.fcMomentToString || (depth0 && depth0.fcMomentToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.end), "tiny", options) : helperMissing.call(depth0, "fcMomentToString", (depth0 && depth0.end), "tiny", options)))
    + "\"\n            aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.time_block_row")
  },data:data},helper ? helper.call(depth0, "calendar.time_block_row.end_time_label", "End Time", options) : helperMissing.call(depth0, "t", "calendar.time_block_row.end_time_label", "End Time", options)))
    + escapeExpression((helper = helpers.datepickerScreenreaderPrompt || (depth0 && depth0.datepickerScreenreaderPrompt),options={hash:{},data:data},helper ? helper.call(depth0, "time", options) : helperMissing.call(depth0, "datepickerScreenreaderPrompt", "time", options)))
    + "\"\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.locked), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " type=\"text\"\n            data-tooltip title=\""
    + escapeExpression((helper = helpers.accessibleDateFormat || (depth0 && depth0.accessibleDateFormat),options={hash:{},data:data},helper ? helper.call(depth0, "time", options) : helperMissing.call(depth0, "accessibleDateFormat", "time", options)))
    + "\"/>\n        </span>\n      </div>\n  </td>\n  <td class=\"delete-column\">\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.locked), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </td>\n</tr>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  